import React, { Fragment } from "react";

/**
 * Preserves user-entered newlines:
 *   First, grab any groups of 2 or more \n's and change to exactly 2 <br />'s .
 *   Then, change any remaining single \n's into a single <br />.
 * Doing split-and-reassemble so we don't have to dangerouslySetInnerHtml() with user-supplied content.
 */
export function FormattedText({ text }: { text: string }) {
  return (
    <>
      {text.split(/(?:\s*\n){2,}/).map((chunk, i) => (
        <Fragment key={chunk}>
          {!!i && (
            <>
              <br />
              <br />
            </>
          )}
          {chunk.split(/\n/).map((innerChunk, j) => (
            <Fragment key={innerChunk}>
              {!!j && <br />}
              {innerChunk}
            </Fragment>
          ))}
        </Fragment>
      ))}
    </>
  );
}
